import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import _ from "lodash";

import { setIsLoading } from "redux/loader/action";
import { set_team_opts, set_create_opt_phase } from "redux/opt/action";
import Socket from "socket/socket";
import Header from "./components/Header";
import DeleteModal from "./components/DeleteModal";
import AddTeammateModal from "./components/AddTeammateModal";
import AddEvent from "./screens/AddEvent";
import EventList from "./screens/EventList";
import SideBarTabs from "../landingLibrary/sideBarTabs";

const OPT = ({ history }) => {
  const {
    optReducer: { team_opts, opt_details, event_details, create_opt_phase },
    gameReducer: {
      currentUser,
      gamesData: {
        OPT: {
          modal: {
            add_teammate: add_teammate_params,
            remove_modal: remove_modal_params
          },
          add_event: add_event_params,
          event_list: event_list_params
        }
      }
    }
  } = useSelector((state) => state);
  const dispatch = useDispatch();

  const current_user = useSelector((state) => state?.gameReducer?.currentUser);

  const [teamMembers, setTeamMembers] = useState([]);
  const [deleteEventModalOpen, setDeleteEventModalOpen] = useState(false);
  const [deleteParticipantModalOpen, setDeleteParticipantModalOpen] =
    useState(false);
  const [addTeammateModalOpen, setAddTeammateModalOpen] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [removedUserDetails, setRemovedUserDetails] = useState({});
  const [removedOptDetails, setRemovedOptDetails] = useState({});

  const handleToggleLoading = (value) => dispatch(setIsLoading(value));

  useEffect(() => {
    return Socket.addListener("opt-get", handle_opt_get, handle_opt_get_error);
  }, []);

  useEffect(() => {
    handleToggleLoading(true);
    let data = {
      action: "opt-get",
      team_code: currentUser.team.id
    };
    Socket.sendMessage(data);
  }, []);

  const handle_opt_get = (res) => {
    if (res) {
      dispatch(set_team_opts(res.team_opts));
      handleToggleLoading(false);
    }
  };
  const handle_opt_get_error = () => handleToggleLoading(false);

  useEffect(() => {
    return Socket.addListener(
      "opt-delete",
      handle_opt_delete,
      handle_opt_delete_error
    );
  }, [removedOptDetails]);

  const handle_opt_delete = (res) => {
    if (res) {
      const array = team_opts.filter(
        (opt) => opt.opt_id !== removedOptDetails.opt_id
      );
      handleToggleLoading(false);
      dispatch(set_team_opts(array));
      toggleDeleteEventModal();
      setRemovedOptDetails({});
    }
  };

  const handle_opt_delete_error = () => {
    handleToggleLoading(false);
  };

  useEffect(() => {
    if (
      !_.isEmpty(currentUser?.team?.users) &&
      !history.location.pathname.includes("edit")
    ) {
      const array = currentUser.team.users.map((user) => ({
        ...user,
        selected: false
      }));
      setTeamMembers(array);
    }
  }, [currentUser?.team?.users, history.location.pathname]);

  const handleSaveTemmates = () => {
    if (!_.isEmpty(teamMembers)) {
      const array = teamMembers.filter((item) => item.selected);
      setSelectedUsers(array);
    }
    toggleAddTeammateModal();
  };

  const toggleDeleteEventModal = () => setDeleteEventModalOpen((prev) => !prev);

  const toggleDeleteParticipantModal = () =>
    setDeleteParticipantModalOpen((prev) => !prev);

  const toggleAddTeammateModal = () => {
    const array = teamMembers.map((item) => ({ ...item, selected: false }));
    setTeamMembers(array);
    setAddTeammateModalOpen((prev) => !prev);
  };

  const handleAddTeammateModalOpen = () => {
    const array = teamMembers.map((item) => ({
      ...item,
      selected: selectedUsers.find((c) => c.Username === item.Username)
        ? true
        : false
    }));
    setTeamMembers(array);
    setAddTeammateModalOpen(true);
  };

  const handleDeleteOpt = () => {
    handleToggleLoading(true);
    let data = {
      action: "opt-delete",
      opt_id: removedOptDetails.opt_id,
      team_code: removedOptDetails.team_code
    };
    Socket.sendMessage(data);
  };

  const handleSelectRemovedUser = (user) => {
    setRemovedUserDetails(user);
    toggleDeleteParticipantModal();
  };

  const handleSelectRemovedOpt = (opt) => {
    setRemovedOptDetails(opt);
    toggleDeleteEventModal();
  };

  const handleDeleteTeammate = () => {
    const array = selectedUsers.filter(
      (user) => user.Username !== removedUserDetails.Username
    );
    setSelectedUsers(array);
    toggleDeleteParticipantModal();
  };

  useEffect(() => {
    if (
      addTeammateModalOpen ||
      deleteEventModalOpen ||
      deleteParticipantModalOpen
    ) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [addTeammateModalOpen, deleteEventModalOpen, deleteParticipantModalOpen]);

  const isStepOneValidate = () =>
    event_details.title !== "" &&
    event_details.type !== "" &&
    event_details.category !== "" &&
    event_details.start_timestamp !== "" &&
    event_details.end_timestamp !== "";

  const isStepTwoValidate = () => !_.isEmpty(event_details.participants);

  const handleBackClick = () => {
    if (create_opt_phase === "two") {
      dispatch(set_create_opt_phase("one"));
    } else {
      history.push({
        pathname: "/outside_team_building"
      });
    }
  };

  const handleNextClick = () => {
    if (isStepOneValidate()) {
      dispatch(set_create_opt_phase("two"));
    }
  };

  const handleFinishClick = () => {
    if (isStepOneValidate() && isStepTwoValidate()) {
      handleToggleLoading(true);
      let data = {};
      if (!_.isEmpty(opt_details)) {
        data = {
          action: "opt-update",
          team_code: currentUser.team.id,
          opt_id: opt_details.opt_id,
          user_id: currentUser.userId,
          title: event_details.title,
          type: event_details.type,
          category: event_details.category,
          start_timestamp: event_details.start_timestamp,
          end_timestamp: event_details.end_timestamp,
          participants: event_details.participants
        };
      } else {
        data = {
          action: "opt-create",
          team_code: currentUser.team.id,
          user_id: currentUser.userId,
          title: event_details.title,
          type: event_details.type,
          category: event_details.category,
          start_timestamp: event_details.start_timestamp,
          end_timestamp: event_details.end_timestamp,
          participants: event_details.participants
        };
      }
      Socket.sendMessage(data);
    }
  };

  return (
    <div className="opt-main">
      <Row>
        <Col md={1} lg={1} className="p-0">
          <SideBarTabs current_user={current_user} handleOptClick={() => {}} />
        </Col>
        <Col md={11} lg={11}>
          <Container>
            <Header event_list_params={event_list_params} />
            <div className="opt-page">
              {history.location.pathname.includes("edit") ? (
                <AddEvent
                  history={history}
                  teamMembers={teamMembers}
                  selectedUsers={selectedUsers}
                  setTeamMembers={setTeamMembers}
                  users={currentUser?.team?.users}
                  setSelectedUsers={setSelectedUsers}
                  add_event_params={add_event_params}
                  onDeleteModalOpen={handleSelectRemovedUser}
                  onTeamModalOpen={handleAddTeammateModalOpen}
                />
              ) : history.location.pathname.includes("add_event") ? (
                <AddEvent
                  history={history}
                  teamMembers={teamMembers}
                  selectedUsers={selectedUsers}
                  setTeamMembers={setTeamMembers}
                  users={currentUser?.team?.users}
                  setSelectedUsers={setSelectedUsers}
                  add_event_params={add_event_params}
                  onDeleteModalOpen={handleSelectRemovedUser}
                  onTeamModalOpen={handleAddTeammateModalOpen}
                />
              ) : (
                <EventList
                  history={history}
                  team_opts={team_opts}
                  setSelectedUsers={setSelectedUsers}
                  event_list_params={event_list_params}
                  onDeleteModalOpen={handleSelectRemovedOpt}
                />
              )}
            </div>
            {deleteEventModalOpen && (
              <DeleteModal
                event
                onDelete={handleDeleteOpt}
                name={removedOptDetails.title}
                onClose={toggleDeleteEventModal}
                remove_modal_params={remove_modal_params}
              />
            )}
            {addTeammateModalOpen && (
              <AddTeammateModal
                teamMembers={teamMembers}
                onSave={handleSaveTemmates}
                setTeamMembers={setTeamMembers}
                onClose={toggleAddTeammateModal}
                add_teammate_params={add_teammate_params}
              />
            )}
            {deleteParticipantModalOpen && (
              <DeleteModal
                name={removedUserDetails.name}
                onDelete={handleDeleteTeammate}
                onClose={toggleDeleteParticipantModal}
                remove_modal_params={remove_modal_params}
              />
            )}
          </Container>
        </Col>
      </Row>
      {(history.location.pathname.includes("add_event") ||
        history.location.pathname.includes("edit")) && (
        <section className="create-event-footer">
          <Container>
            <Row>
              <Col md={7}>
                <p style={{ textTransform: "uppercase" }}>Create New Event</p>
                <h2>
                  {create_opt_phase === "one"
                    ? " Step 1 - Event Details"
                    : "Step 2 - Invite Participants"}
                </h2>
              </Col>
              <Col md={5} className="text-right">
                <div className="challange-content">
                  <div>
                    <div className="btn-div">
                      <div
                        className="back-button back"
                        onClick={handleBackClick}
                      >
                        Back
                      </div>
                      {create_opt_phase === "one" && (
                        <div
                          className={`back-button create ${
                            isStepOneValidate() ? "enabled" : ""
                          }`}
                          onClick={handleNextClick}
                        >
                          Next
                        </div>
                      )}
                      {create_opt_phase === "two" && (
                        <div
                          className={`back-button create ${
                            isStepOneValidate() && isStepTwoValidate()
                              ? "enabled"
                              : ""
                          }`}
                          onClick={handleFinishClick}
                        >
                          Finish
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      )}
    </div>
  );
};

export default OPT;
